<template>
  <div class="third-party-box">
    <a
      :class="[className, `j-${item}-login-btn`]"
      href="javascript:;"
      v-for="(item, index) in thirdList"
      :key="index"
      @click="loginHrefJump(loginHref[item], isOpenInIframe ? '_blank' : false, item)"
      v-show="index < 4 || showAllLogin"
    >
      <em :class="item"></em>
      <span>{{ channelName[item] }}</span>
    </a>
    <a
      v-if="showUidTokenWay"
      class="login-type j-uid-login-btn"
      href="javascript:;"
      @click="goUidTokenLogin"
    >
      <em class="uid"></em>
      <span>{{ letter.uidLoginName }}</span>
    </a>
    <div
      class="showAllGame"
      style="margin-top: 2.22vh"
      @click="handleShowAllLogin"
      v-if="!showAllLogin && isHideLogin"
    >
      <span>more</span>
      <i class="dropdown"></i>
    </div>
    <button class="accout-info j-account-info" @click="showPopup">
      {{ letter.thirdInfo }}
    </button>
  </div>
</template>

<script>
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import { reportActivityPoint } from '../../utiles/webLogin/activityPoint.js';

export default {
  name: 'thirdLoginPage',
  data() {
    return {
      channelName: CHANNEL_NAME,
      isOpenInIframe: false,
      showAllLogin: false
    };
  },
  computed: {
    className() {
      // if (this.$store.state.thirdList.length > 1) {
      //   return 'login-type';
      // } else {
      //   return 'login-type one';
      // }
      return 'login-type';
    },
    isHideLogin() {
      return this.thirdList.length > 4;
    }
  },
  mixins: [login],
  methods: {
    showPopup() {
      this.$emit('showPopup', {
        title: this.letter.thirdInfo,
        content: this.letter.thirdInfoContent
      });
    },
    loginHrefJump(href, target, channel) {
      reportActivityPoint('third_party_login_click', {
        eventType: 'third_party_login',
        eventReason: 'click_button',
        eventValue: { channel, target }
      });
      window.open(href, target ? '_blank' : '_self');
    },
    handleShowAllLogin() {
      this.showAllLogin = true;
    }
  },
  created() {
    this.isOpenInIframe = window.self !== window.top;
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/webLogin-v3.scss';

// .login-type {
//   cursor: auto;
//   display: inline-block;
//   margin: 0 auto 3vh;
//   text-decoration: none;
//   width: 50%;
//   text-align: center;
//   span {
//     margin-top: 2.4vh;
//     margin-bottom: 0;
//     color: $font;
//     transition: all 0.2s;
//     display: block;
//     font-size: 2.4vh;
//   }

//   &:hover {
//     cursor: pointer;
//     span {
//       color: $green;
//     }
//     i {
//       border: 1px solid $green;
//     }
//   }
// }
</style>
